module.exports = __webpack_public_path__ + "img/views-black.d5a639de.svg";